module.exports = __webpack_public_path__ + "img/logo.d8c6ea2a.png";